import React from "react";

function Logo() {
  return (
    <div>
      <div className="navbar-brand fw-bold">
        <img src="/images/nabtah.png" style={{ width: "100px" }} alt="logo" />
      </div>
    </div>
  );
}

export default Logo;
